export default __webpack_public_path__ + "static/media/14.f23ff6b6.jpg";